// Removable chips that mirror the currently selected filter values.

import React from 'react';
import { XIcon } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';

export type FilterBadgeItem = {
  id: string;
  label: string;
  onRemove: () => void;
};

type FilterBadgesProps = {
  items: FilterBadgeItem[];
};

const FilterBadges: React.FC<FilterBadgesProps> = ({ items }) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className="hidden flex-wrap items-center gap-2 sm:flex">
      {items.map((item) => (
        <Badge
          key={item.id}
          variant="secondary"
          className="h-7 gap-1 rounded-full pl-2 pr-1"
        >
          <span className="max-w-48 truncate">{item.label}</span>
          <Button
            type="button"
            variant="ghost"
            size="icon-xs"
            className="rounded-full"
            aria-label={`Remove ${item.label}`}
            onClick={item.onRemove}
          >
            <XIcon />
          </Button>
        </Badge>
      ))}
    </div>
  );
};

export default FilterBadges;
